import { render, staticRenderFns } from "./OrderSend.vue?vue&type=template&id=2a1ace33&scoped=true&"
import script from "./OrderSend.vue?vue&type=script&lang=js&"
export * from "./OrderSend.vue?vue&type=script&lang=js&"
import style0 from "./OrderSend.vue?vue&type=style&index=0&id=2a1ace33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1ace33",
  null
  
)

export default component.exports